import { SelectHTMLAttributes } from 'react';
import { formatMillisecondsToHours } from 'helpers';
import { ONE_MINUTE_MILLISECONDS } from 'commons';
import * as S from './styles';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  value: number;
  hasError?: boolean;
}

const THIRTY_MINUTES_MILLISECONDS = 30 * ONE_MINUTE_MILLISECONDS;

export function HourSelect({
  name,
  children,
  hasError = false,
  ...rest
}: Props) {
  const { value, disabled } = rest;
  const isValidValue = value % THIRTY_MINUTES_MILLISECONDS === 0;

  if (disabled) {
    return (
      <S.Select {...rest} disabled id={name}>
        <option value={value}>00:00</option>
      </S.Select>
    );
  }

  const { hours, minutes } = formatMillisecondsToHours(value);

  return (
    <S.Select $error={hasError} {...rest} id={name}>
      {children}

      {!isValidValue && (
        <option hidden disabled key={value} value={value}>
          {hours}:{minutes}
        </option>
      )}
    </S.Select>
  );
}
